export const paymentMethodTypes = {
  ach: 'ach',
  creditCard: 'credit_card',
  cashApp: 'cashapp',
};

export const DECLINED_STATUS = 'declined';
